import React from "react";
import { Link } from "react-router-dom";
import dotshape from "../assests/image/img/shape/dots-shape.png";
import privacypolicy from "../assests/image/img/privacypolicy.webp";

function PrivacyPolicy() {
  return (
    <>
      <div
        className="inner-banner"
        style={{
          background: `url(${privacypolicy}) center center no-repeat`,
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row inner-title text-center">
            <div className="col-lg-6">
              <div className="about-widget-img breadcrumb-itd">
                <h3>Privacy Policy</h3>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>
                  </li>
                  <li>Privacy Policy</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="inner-banner-shape">
            <div className="inner-banner-dots">
              <img src={dotshape} alt="Images" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
      <div className="service-list-area pt-100 pb-70">
        <div className="container">
          <div className="section-title text-center">
            <span className="sp-before sp-after"></span>
            <h2>Privacy Policy</h2>
          </div>

          <div className="row pt-45">
            <div className="col-lg-12 col-md-6">
              <div className="service-list-content">
                <p style={{ textAlign: "justify" }}>
                  This privacy policy ("Policy") will help you understand how
                  <strong> ITDOSE INFOSYSTEMS </strong> ("us", "we", "our") uses
                  and protects the data you provide to us when you visit and use
                  [https://www.itdoseinfo.com/] ("service").
                </p>

                <p style={{ textAlign: "justify" }}>
                  We reserve the right to change this policy at any given time,
                  of which you will be promptly updated. If you want to make
                  sure that you are up to date with the latest changes, we
                  advise you to frequently visit this page.
                </p>

                <h3>What User Data We Collect</h3>
                <p style={{ textAlign: "justify" }}>
                  When you visit the ITDOSE INFOSYSTEMS website, we may collect
                  the following data:
                </p>
                <p>• Your IP address.</p>
                <p>• Your contact information and email address.</p>
                <p>• Other information such as interests and preferences.</p>
                <p>
                  • Data profile regarding your online behavior on our ITDOSE
                  INFOSYSTEMS Website.
                </p>

                <h3>Why We Collect Your Data</h3>
                <p style={{ textAlign: "justify" }}>
                  We are collecting your data for several reasons:
                </p>
                <p>• To better understand your needs.</p>
                <p>• To improve our services and products.</p>
                <p>
                  • To send you promotional emails containing the information we
                  think you will find interesting.
                </p>
                <p>
                  • To contact you to fill out surveys and participate in other
                  types of market research.
                </p>
                <p>
                  • To customize our ITDOSE INFOSYSTEMS Website according to
                  your online behavior and personal preferences.
                </p>

                <h3>Safeguarding and Securing the Data</h3>
                <p style={{ textAlign: "justify" }}>
                  ITDOSE INFOSYSTEMS is committed to securing your data and
                  keeping it confidential. ITDOSE INFOSYSTEMS has done all in
                  its power to prevent data theft, unauthorized access, and
                  disclosure by implementing the latest technologies and
                  software, which help us safeguard all the information we
                  collect online.
                </p>

                <h3>Our Cookie Policy</h3>
                <p style={{ textAlign: "justify" }}>
                  Once you agree to allow our ITDOSE INFOSYSTEMS Website to use
                  cookies, you also agree to use the data it collects regarding
                  your online behavior (analyze web traffic, web pages you
                  visit, and spend the most time on).
                </p>
                <p style={{ textAlign: "justify" }}>
                  The data we collect by using cookies is used to customize our
                  ITDOSE INFOSYSTEMS Website to your needs. After we use the
                  data for statistical analysis, the data is completely removed
                  from our systems.
                </p>
                <p style={{ textAlign: "justify" }}>
                  Please note that cookies don't allow us to gain control of
                  your computer in any way. They are strictly used to monitor
                  which pages you find useful and which you do not so that we
                  can provide a better experience for you.
                </p>
                <p style={{ textAlign: "justify" }}>
                  If you want to disable cookies, you can do it by accessing the
                  settings of your internet browser. You can visit
                  https://www.internetcookies.com, which contains comprehensive
                  information on how to do this on a wide variety of browsers
                  and devices.
                </p>

                <h3>Links to Other Websites</h3>
                <p style={{ textAlign: "justify" }}>
                  Our ITDOSE INFOSYSTEMS Website contains links that lead to
                  other websites. If you click on these links ITDOSE INFOSYSTEMS
                  is not held responsible for your data and privacy protection.
                  Visiting those websites is not governed by this privacy policy
                  agreement. Make sure to read the privacy policy documentation
                  of the website you go to from our website.
                </p>

                <h3>Restricting the Collection of your Personal Data</h3>
                <p style={{ textAlign: "justify" }}>
                  At some point, you might wish to restrict the use and
                  collection of your personal data. You can achieve this by
                  doing the following:
                </p>
                <p style={{ textAlign: "justify" }}>
                  When you are filling out the forms on the ITDOSE INFOSYSTEMS
                  Website, make sure to check if there is a box that you can
                  leave unchecked, if you don't want to disclose your personal
                  information.
                </p>
                <p style={{ textAlign: "justify" }}>
                  If you have already agreed to share your information with us,
                  feel free to contact us via email and we will be more than
                  happy to change this for you.
                </p>
                <p style={{ textAlign: "justify" }}>
                  ITDOSE INFOSYSTEMS will not lease, sell or distribute your
                  personal information to any third parties, unless we have your
                  permission. We might do so if the law forces us. Your personal
                  information will be used when we need to send you promotional
                  materials if you agree to this privacy policy.
                </p>
                  <h3>Mobile Application: Raise Ticket</h3>
                <p style={{ textAlign: "justify", fontSize: "15px", fontWeight: "bold" }}>
                 Raise Ticket is an internal employee support and ticket management
                application developedand managed by ITDOSE INFOSYSTEMS PVT LTD.
                </p>
                <p style={{ textAlign: "justify" }}>
                  This Privacy Policy explains how the application collects, uses, and 
                  protects user information.
                </p>
                <span style={{ textAlign: "justify", fontSize: "15px", fontWeight: "bold" }}>
                 Information We Collect:
                 </span>
                  <p>
                 The application may collect and process the following information:
                  Employee username and login credentials
                  Employee profile information
                  Ticket details submitted by users
                  Ticket status, comments, and assignments
                  
                 </p>
                <span style={{ textAlign: "justify", fontSize: "15px", fontWeight: "bold" }}>
                 The collected information is used only for:
                </span>
                <p style={{ textAlign: "justify" }}>
                 User authentication and secure login
                 Managing support and service tickets
                 Assigning and tracking tickets
                 Updating ticket status and communication

                </p>
                <p style={{ textAlign: "justify" }}>
                <span style ={{ fontWeight: "700" }}>Note: 
                ITDOSE INFOSYSTEMS PVT LTD does not sell, trade, or share employee personal information with third parties except when required for legal, operational, or security purposes.
                </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
